module.exports = __webpack_public_path__ + "public/img/logo-adgi.4ba85a2d.jpg";